"use client";

import { useState } from "react";
import ModeChoice from "../../../components/ModeChoice";
import ReadingInput from "../../../components/ReadingInput";
import SiteHeader from "../../../components/site/SiteHeader";
import { readingStore } from "../../../lib/storage";

export default function NewReadingPage() {
  const [saved, setSaved] = useState<{ id: string; title: string } | null>(
    null,
  );

  async function handleSaved(id: string) {
    const reading = await readingStore.getReading(id);
    setSaved({ id, title: reading?.title ?? "your reading" });
  }

  return (
    <div className="min-h-dvh bg-ink">
      <SiteHeader />
      <main className="rise-in mx-auto max-w-4xl px-5 py-20 sm:px-8">
        <h1 className="mb-3 font-heading text-[clamp(32px,4vw,48px)] leading-tight text-paper">
          Add a reading
        </h1>
        <p className="mb-10 font-body text-base leading-relaxed text-muted-dark">
          Upload a PDF, or paste the text. Syft rebuilds it in the order it
          should have been written in.
        </p>
        {saved ? (
          <ModeChoice readingId={saved.id} title={saved.title} />
        ) : (
          <ReadingInput onSaved={handleSaved} />
        )}
      </main>
    </div>
  );
}
